var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34375 1.98H6.125C6.24531 1.98 6.34375 1.881 6.34375 1.76V1.98H14.6562V1.76C14.6562 1.881 14.7547 1.98 14.875 1.98H14.6562V3.96H16.625V1.76C16.625 0.78925 15.8402 0 14.875 0H6.125C5.15977 0 4.375 0.78925 4.375 1.76V3.96H6.34375V1.98ZM20.125 3.96H0.875C0.391016 3.96 0 4.35325 0 4.84V5.72C0 5.841 0.0984375 5.94 0.21875 5.94H1.87031L2.5457 20.3225C2.58945 21.2603 3.36055 22 4.29297 22H16.707C17.6422 22 18.4105 21.263 18.4543 20.3225L19.1297 5.94H20.7812C20.9016 5.94 21 5.841 21 5.72V4.84C21 4.35325 20.609 3.96 20.125 3.96ZM16.4965 20.02H4.50352L3.8418 5.94H17.1582L16.4965 20.02Z",
    fill: "#2F2F5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.9bc8b388.svg";
export { ForwardRef as ReactComponent };